/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Prefix_LabelInputs */

const en_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefix Character`)
};

const fr_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractère de préfixe`)
};

const de_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Präfixzeichen`)
};

const it_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carattere prefisso`)
};

const ru_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Префиксный символ`)
};

const es_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carácter de prefijo`)
};

const zh_cn2_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前缀字符`)
};

const ja_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接頭辞文字`)
};

const hi_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपसर्ग वर्ण`)
};

const pt_pt2_insert_speaker_prefix_label = /** @type {(inputs: Insert_Speaker_Prefix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractere de prefixo`)
};

/**
* | output |
* | --- |
* | "Prefix Character" |
*
* @param {Insert_Speaker_Prefix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_prefix_label = /** @type {((inputs?: Insert_Speaker_Prefix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Prefix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_prefix_label(inputs)
	if (locale === "de") return de_insert_speaker_prefix_label(inputs)
	if (locale === "it") return it_insert_speaker_prefix_label(inputs)
	if (locale === "ru") return ru_insert_speaker_prefix_label(inputs)
	if (locale === "es") return es_insert_speaker_prefix_label(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_prefix_label(inputs)
	if (locale === "ja") return ja_insert_speaker_prefix_label(inputs)
	if (locale === "hi") return hi_insert_speaker_prefix_label(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_prefix_label(inputs)
	return en_insert_speaker_prefix_label(inputs)
});